import { render } from "./AceEditorVue.vue?vue&type=template&id=49e9c9e2&ts=true"
import script from "./AceEditorVue.vue?vue&type=script&lang=ts"
export * from "./AceEditorVue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__